const state =
    {
        contact: {},
        newContact: true,
        contactData: {
            gender: null,
            firstName: "",
            lastName: "",
            referrerId: 0,
            typeId: 1,
            password: "",
            options: [
                {
                    typeId: 2,
                    subTypeId: 4,
                    value: "",
                    priority: 0
                },
                {
                    typeId: 1,
                    subTypeId: 4,
                    value: "",
                    priority: 0
                }
            ]
        },
        billingAddressData: {
            address1: "",
            address2: "",
            address3: "",
            name1: "",
            name2: "",
            name3: "",
            postalCode: "",
            town: "",
            telephone: "",
            email: "",
            stateId: null,
            countryId: 0,
            vatNumber: "",
            useAddressLightValidator: true
        },
        bankData: {
            iban: "",
            accountOwner: "",
            contactId: 0,
            bic: "",
            accountNumber: "",
            sortCode: null,
            lastUpdateBy: "customer",
            directDebitMandateAvailable: 1
        },
        allowedMethodsOfPayment: [
            {
                contactId: 0,
                methodOfPaymentId: 3,
                allowed: true
            }
        ],
        countryIsoCode: "",
        countryName: "",
        directDebitId: 3,
        invoiceId: 2,
        paymentMethod: 3,
        referrer: "",
        referrerMap: {
            i: 910,
            // eslint-disable-next-line
            s: 911,
            // eslint-disable-next-line
            a: 912,
            // eslint-disable-next-line
            f: 913,
            // eslint-disable-next-line
            p: 914
        },
        orderContactQuantity: 1,
        contactOrders: {
            value: 0,
            internalValues: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            list: {
                de: ["< 500", "500", "1.000", "1.500", "2.500", "5.000", "7.500", "10.000", "20.000", "> 20.000"],
                en: ["< 500", "500", "1,000", "1,500", "2,500", "5,000", "7,500", "10,000", "20,000", "> 20,000"],
                es: ["< 500", "500", "1,000", "1,500", "2,500", "5,000", "7,500", "10,000", "20,000", "> 20,000"],
                pl: ["< 500", "500", "1.000", "1.500", "2.500", "5.000", "7.500", "10.000", "20.000", "> 20.000"]
            }
        }
    };

const mutations =
    {
        setContact(state, payload)
        {
            if (payload !== null && payload.id && payload.id > 0)
            {
                state.newContact = false;
                state.contact = payload;
                this.commit("setBankDetails", payload.banks);
                this.commit("setBillingAddress", payload.primaryBillingAddress);
                this.commit("setAllowedMethodOfPayments", payload.allowedMethodsOfPayment);
            }
        },

        setAllowedMethodOfPayments(state, payload)
        {
            if (payload !== null && payload.length > 0)
            {
                state.allowedMethodsOfPayment = payload;
            }
        },

        setBankDetails(state, payload)
        {
            if (payload !== null && payload.length > 0)
            {
                state.bankData = payload[0];
            }
        },

        setBillingAddress(state, payload)
        {
            if (payload !== null && payload.length > 0)
            {
                state.billingAddressData = payload[0];
            }
        },

        setBillingAddressData(state, payload)
        {
            state.billingAddressData[payload.field] = payload.value;
        },

        setContactData(state, payload)
        {
            state.contactData[payload.field] = payload.value;
        },

        setBankData(state, payload)
        {
            state.bankData[payload.field] = payload.value;
        },

        setTagReferrer(state, payload)
        {
            state.referrer = state.referrerMap[payload] || "";
        },

        setContactOrders(state, payload)
        {
            state.contactOrders.value = payload;
        },

        setPaymentMethodId(state, payload)
        {
            const paymentMethodId = parseInt(payload);

            state.paymentMethod = payload;

            if (!state.allowedMethodsOfPayment.find(method => method.methodOfPaymentId === paymentMethodId))
            {
                state.allowedMethodsOfPayment[0].methodOfPaymentId = payload;
            }

            for (let i = 0; i < state.allowedMethodsOfPayment.length; i++)
            {
                state.allowedMethodsOfPayment[i].allowed = state.allowedMethodsOfPayment[i].methodOfPaymentId === paymentMethodId;
            }

            state.bankData.directDebitMandateAvailable = paymentMethodId === state.directDebitId ? 1 : 0;
        },

        setCountryDetails(state, payload)
        {
            state.bankData.sortCode = null;
            state.countryName = payload.currLangName;
            state.countryIsoCode = payload.isoCode2;
        },

        onRegistrationResponse(state, payload)
        {
            state.contact = payload;
            state.bankData.contactId = state.contact.id;
            state.allowedMethodsOfPayment[0].contactId = state.contact.id;
        },

        prepareContactData(state)
        {
            if (state.referrer.length > 0)
            {
                state.contactData.tagRelationships = [
                    {
                        tagType: "contact",
                        tagId: state.referrerMap[state.referrer]
                    }
                ];
            }

            state.contactData.options[0].value = state.billingAddressData.email;
            state.contactData.options[1].value = state.billingAddressData.telephone;

            state.billingAddressData.name2 = state.contactData.firstName;
            state.billingAddressData.name3 = state.contactData.lastName;
        },

        convertSortCode(state)
        {
            if (state.bankData.sortCode !== null && state.bankData.sortCode.length > 0)
            {
                state.bankData.sortCode = parseInt(state.bankData.sortCode);
            }
            else
            {
                state.bankData.sortCode = null;
            }
        }
    };

const actions =
    {
        checkIfEmailInUse({commit, state})
        {
            return new Promise(resolve =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 200)
                    {
                        resolve({inuse: false});
                    }
                    else if (this.readyState === 4 && this.status > 200)
                    {
                        resolve({inuse: true});
                    }
                };

                xHttp.open("POST", "/rest/checkout/assistant/contact", true);
                xHttp.setRequestHeader("Content-type", "application/json");
                xHttp.send(JSON.stringify({
                    dryRun: true,
                    contact: state.contactData,
                    billingAddress: state.billingAddressData,
                    contactOrderValue: state.contactOrders.internalValues[state.contactOrders.value]
                }));
            });
        },

        saveContact({dispatch, commit, state})
        {
            commit("prepareContactData");

            if (state.contact.id && state.contact.id > 0)
            {
                return dispatch("updateContactWithAddress");
            }

            return new Promise((resolve, reject) =>
            {
                dispatch("registerContact").then(response =>
                {
                    resolve(response);
                }, error =>
                {
                    reject(error);
                });
            });
        },

        registerContact({commit, state})
        {
            return new Promise((resolve, reject) =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 200)
                    {
                        commit("onRegistrationResponse", JSON.parse(this.responseText).data);
                        resolve({data: "ok"});
                    }
                    else if (this.readyState === 4 && this.status > 200)
                    {
                        reject(JSON.parse(this.responseText));
                    }
                };

                xHttp.open("POST", "/rest/checkout/assistant/contact", true);
                xHttp.setRequestHeader("Content-type", "application/json");
                xHttp.send(JSON.stringify({
                    contact: state.contactData,
                    billingAddress: state.billingAddressData,
                    contactOrderValue: state.contactOrders.internalValues[state.contactOrders.value]
                }));
            });
        },

        updateContactWithAddress({commit, state})
        {
            return new Promise(resolve =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 200)
                    {
                        commit("onRegistrationResponse", JSON.parse(this.responseText).data);
                        resolve({data: "ok"});
                    }
                    else if (this.readyState === 4 && this.status > 200)
                    {
                        resolve(JSON.parse(this.responseText));
                    }
                };

                xHttp.open("PUT", "/rest/checkout/assistant/contact/" + state.contact.addresses[0].id, true);
                xHttp.setRequestHeader("Content-type", "application/json");
                xHttp.send(JSON.stringify({billingAddress: state.billingAddressData}));
            });
        },

        updateContactAddress({state})
        {
            const params = state.billingAddressData;

            params.typeId = 1;
            params.isPrimary = 1;

            return new Promise(resolve =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 200)
                    {
                        resolve({data: "ok"});
                    }
                    else if (this.readyState === 4 && this.status > 200 && this.status < 400)
                    {
                        resolve(JSON.parse(this.responseText));
                    }
                };

                xHttp.open("POST", "/rest/io/customer/address/", true);
                xHttp.setRequestHeader("Content-type", "application/json");
                xHttp.send(JSON.stringify(params));
            });
        },

        createPaymentData({commit, state})
        {
            commit("convertSortCode");

            const saveBankData = state.paymentMethod === state.invoiceId ? null : state.bankData;

            return new Promise(resolve =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 201)
                    {
                        resolve(JSON.parse(this.responseText));
                    }
                };

                xHttp.open("POST", "/rest/checkout/assistant/payment_data", true);
                xHttp.setRequestHeader("Content-type", "application/json");
                xHttp.send(JSON.stringify(
                    {
                        bankData: saveBankData,
                        allowedMethodsOfPayment: state.allowedMethodsOfPayment
                    }
                ));
            });
        },

        changePaymentMethod({state, commit}, payload)
        {
            commit("setPaymentMethodId", payload);
        },

        logout()
        {
            return new Promise(resolve =>
            {
                const xHttp = new XMLHttpRequest();

                xHttp.onreadystatechange = function()
                {
                    if (this.readyState === 4 && this.status === 200)
                    {
                        resolve();
                    }
                };

                xHttp.open("POST", "/rest/io/customer/logout", true);
                xHttp.setRequestHeader("Content-type", "application/json");
                xHttp.send();
            });
        }
    };

const getters =
    {
        contactIdExist()
        {
            return state.contact && state.contact.id && state.contact.id > 0;
        }
    };

export default {
    state,
    mutations,
    actions,
    getters
};
